module.exports = __webpack_public_path__ + "static/fundamental2-8896070e43d8fca169b65405e6312485.jpg";